import { GENERAL_FORM_CONSTANTS } from "src/forms/constants";
import { FormValidationType } from "../../../../types";
import { CLAIM_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_CLAIM]: {
    required: { value: true },
  },
  [CLAIM_DETAILS_CONSTANTS.QUANTITY]: {
    required: { value: true },
    allowedCharactersRegExp: {
      value: new RegExp(GENERAL_FORM_CONSTANTS.ONLY_NUMBERS_REGEX),
    },
  },
  [CLAIM_DETAILS_CONSTANTS.HANDLING_UNIT_IDENTIFIER]: {
    required: { value: false },
  },
  [CLAIM_DETAILS_CONSTANTS.WEIGHT]: {
    required: { value: false },
    allowedCharactersRegExp: {
      value: new RegExp(GENERAL_FORM_CONSTANTS.ONLY_NUMBERS_REGEX),
    },
  },
  [CLAIM_DETAILS_CONSTANTS.WEIGHT_UNIT_TYPE]: {
    required: { value: false },
  },
  [CLAIM_DETAILS_CONSTANTS.DESCRIPTION_OF_CARGO_OR_PROPERTY]: {
    required: { value: true },
    maxCharacters: { value: 8000 },
  },
  [CLAIM_DETAILS_CONSTANTS.MATERIAL_PART_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [CLAIM_DETAILS_CONSTANTS.AMAZON_PART_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [CLAIM_DETAILS_CONSTANTS.PURCHASE_ORDER_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [CLAIM_DETAILS_CONSTANTS.WAREHOUSE_MANAGEMENT_SYSTEM_ORDER_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [CLAIM_DETAILS_CONSTANTS.AMAZON_STANDARD_IDENTIFICATION_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 150 },
  },
  [CLAIM_DETAILS_CONSTANTS.MULTIPLE_ITEM_CLAIM_ATTACHMENT]: {
    required: { value: true },
  },
};
